// import consts
import { dynamicAssets } from 'js/constants/Paths';

export const parseData = (data) => {
  const allIds = [];
  const byId = {};
  const allUrls = [];

  if (data && data?.length > 0) {
    data.map((item, index) => {
      const parseData = {
        id: item.id,
        friendly_url: item.friendly_url,
        name: item.name,
        meta: {
          title: item.meta_title || '',
          description: item.meta_description || '',
          keywords: item.meta_keywords || '',
        },
      };

      if (item.header_image && item.header_image !== '') {
        item.header_image = dynamicAssets(item.header_image);
      }

      item.type = 'page_template';

      parseData.header = {
        title: item.header_title || '',
        image: item.header_image || '',
        description: item.header_description || '',
      };
      parseData.body = {
        description: item.body_description || '',
      };

      allIds.push(parseData.id);
      byId[parseData.id] = parseData;
      allUrls.push(parseData.friendly_url);
    });
  }

  return { byId, allIds, allUrls };
};
